export const FLEEK_PLAYSTORE_LINK = "https://play.google.com/store/search?q=fleek&c=apps&hl=en_IN&gl=IN";
export const FLEEK_APPSTORE_LINK = "https://apps.apple.com/in/app/fleek-manage-subscriptions/id1604744564";
